module.exports = __webpack_public_path__ + "img/cross_odd_rounded_edge.3c6b9d6.svg";